// Dialog IDs
export const DIALOG_IDS = {
  SAVE_DIALOG: 'save-dialog',
  EXPORT_DIALOG: 'export-dialog',
  ADD_LIST_DIALOG: 'add-list-dialog',
  ADD_LABEL_DIALOG: 'add-label-dialog',
  ASSIGN_OWNER_DIALOG: 'assign-owner-dialog',
} as const;

// Accordion IDs
export const ACCORDION_IDS = {
  LIST: 'list',
  LABEL: 'label',
  INTEGRATION_EXPORT: 'integration-export',
  CSV_EXPORT: 'csv-export',
  AI_LOOKALIKE: 'ai-lookalike',
  ASSIGN_OWNER: 'assign-owner',
  EXPORT_INTEGRATION_NAME: 'export-integration-name',
  EXPORT_NAME: 'export-name',
  EXPORT_SELECT_CAMPAIGN: 'export-select-campaign',
} as const;

// Helper function to get accordion ID with label type
export const getAccordionIdWithType = (type: 'LIST' | 'LABEL') => {
  return type === 'LIST' ? ACCORDION_IDS.LIST : ACCORDION_IDS.LABEL;
};
